<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item md-size-20 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>search</md-icon>
              검색 조건
            </h4>
          </md-card-header>
          <md-card-content>
            <table class="flex-table">
              <tr>
                <th>대상학기</th>
                <td>
                  <select v-model="searchQuery.semesterCd" name="semesterCd">
                    <option value="">선택</option>
                    <option v-for="item in semesterCdList" :key="item.code" :label="item.codeNm" :value="item.code">
                      {{ item }}
                    </option>
                  </select>
                </td>
              </tr>
            </table>
          </md-card-content>
          <md-card-actions>
            <md-button class="md-info md-sm full-size-button" @click="sendQuery">
              <md-icon>check</md-icon>
              검 색
            </md-button>
          </md-card-actions>
        </md-card>
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>receipt_long</md-icon>
              파싱으로 일괄 등록
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="flex-div">
              <h5 class="title">엑셀 업로드</h5>
              <div class="inline-flex mb10">
                <input type="file" class="hidden-input-file" id="excelFileInput" accept=".xlsx">
                <input type="text" v-model="excelFileName" disabled>
                <button @click="onClickSearchExcel">
                  <md-icon>search</md-icon>
                  엑셀 파일 찾기
                </button>
              </div>
              <md-button class="md-success md-sm full-size-button"
                         @click="uploadExcelFile()"
                         :disabled="!excelFile"
              >
                <md-icon>publish</md-icon>
                엑셀 업로드
              </md-button>
            </div>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-80 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>assignment</md-icon>
              검색 결과
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="table-header-info">
              <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
              <div>
                <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                  <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                    {{ item }}
                  </option>
                </select>
              </div>
            </div>

            <grid ref="TuitionList"
                  :data="gridProps.data"
                  :columns="gridProps.columns"
                  :options="gridProps.options"
                  :theme="gridProps.theme"
                  :rowHeaders="gridProps.rowHeaders"
                  :columnOptions="gridProps.columnOptions"
                  :language="gridProps.lang"
                  @click="onClickRow"
                  @response="response"
            ></grid>

          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class="pagination"></div>
            <div>
              <md-button
                class="md-default md-sm"
                @click="deleteTuition"
              >
                <md-icon>clear</md-icon>
                삭 제
              </md-button>

              <md-button class="md-info md-sm" @click="inputShow=true; clearSaveQuery()">
                <md-icon>check</md-icon>
                신규 등록
              </md-button>
            </div>
          </md-card-actions>
        </md-card>

        <md-card v-show="inputShow">
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>assignment</md-icon>
              등록금 상세
            </h4>
          </md-card-header>
          <md-card-content>
            <table class="flex-table">
              <tr>
                <th>대상학기</th>
                <th>캠퍼스</th>
                <th>대학</th>
                <th>학과/학부</th>
                <th>학년</th>
                <th>등록금</th>
              </tr>
              <tr>
                <td>
                  <input type="text" v-model="saveQuery.semesterCd">
                </td>
                <td>
                  <input type="text" v-model="saveQuery.collegeLCd">
                </td>
                <td>
                  <input type="text" v-model="saveQuery.collegeMCd">
                </td>
                <td>
                  <input type="text" v-model="saveQuery.collegeSCd">
                </td>
                <td>
                  <input type="text" v-model="saveQuery.collegeSemesterCd">
                </td>
                <td>
                  <input type="text" v-model="saveQuery.tuitionAmount">
                </td>
              </tr>
            </table>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class="pagination"></div>
            <div>
              <md-button
                class="md-info md-sm"
                @click="updateTuition"
                v-if="saveQuery.insertDate"
              >
                <md-icon>check</md-icon>
                수 정
              </md-button>

              <md-button class="md-info md-sm" @click="addTuition" v-if="!saveQuery.insertDate">
                <md-icon>check</md-icon>
                저 장
              </md-button>
            </div>
          </md-card-actions>
        </md-card>

      </div>
    </div>
  </div>
</template>

<script>
import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import parser from "@/kuaa/kuaa-parser";
import session from "@/kuaa/kuaa-sessions";

import Swal from "sweetalert2";
import moment from "moment";


import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

export default {
  components: {
    Grid
  },
  computed: {
    total() {
      return this.pagination.total;
    }
  },
  created() {
    this.getSemesterCdList();
    this.initGrid();
  },
  data() {
    return {
      inputShow : false,
      excelFile : null,
      excelFileName : '',
      searchQuery : {
        semesterCd : null
      },
      saveQuery : {
        semesterCd : null,
        collegeLCd : null,
        collegeMCd : null,
        collegeSCd : null,
        collegeSemesterCd : null,
        tuitionAmount : null
      },
      semesterCdList : [],
      gridProps: {},
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      }
    }
  },
  methods: {
    getSemesterCdList (){
      kuaaFnc.fncSemesterCodes(null,res => {
        this.semesterCdList = res.data.data.contents;
      });
    },
    resetView(){
      this.inputShow = false;
      this.clearSaveQuery();
      this.sendQuery();
    },
    clearSaveQuery(){
      this.saveQuery = {
        semesterCd : null,
        collegeLCd : null,
        collegeMCd : null,
        collegeSCd : null,
        collegeSemesterCd : null,
        tuitionAmount : null
      }
    },
    sendQuery (){
      this.$refs.TuitionList.invoke("readData", 1, this.searchQuery);
    },
    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_TUITION_LIST, false, this.pagination, ['rowNum', 'checkbox']);
      this.gridProps['el'] = this.$refs.codeGrpGrid;
      this.gridProps['columns']= [
          {header: '대상학기', name: 'semesterCdNm', align : 'center', sortable: true},
          {header: '캠퍼스', name: 'collegeLCdNm', align : 'center', sortable: true},
          {header: '대학', name: 'collegeMCdNm', align : 'center', sortable: true},
          {header: '학과/학부', name: 'collegeSCdNm', align : 'center', sortable: true},
          {header: '학년', name: 'collegeSemesterCdNm', align : 'center', sortable: true},
          {header: '등록금', name: 'tuitionAmount', align : 'center', sortable: true,
            formatter(value) {
              return formatter.getCurrency(value.value);
            }
          }
        ];
      //this.gridSProps['options'].bodyHeight = 300;
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.TuitionList, event, this.pagination);
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
      this.$refs.TuitionList.invoke("refreshLayout");
    },
    onClickRow(e){
      if(e.instance.getRow(e.rowKey) != null) {
        this.inputShow = true;
        this.saveQuery = e.instance.getRow(e.rowKey);
      }
    },

    onClickSearchExcel() {
      let input = document.getElementById("excelFileInput");
      input.onchange = e => {
        let file = e.target.files[0];
        this.excelFileName = file.name;
        this.excelFile = file;
      };
      input.click();
    },

    uploadExcelFile() {
      let xls = this.excelFile;
      parser.parseXlsTuitionBundleData(xls, (res)=>{
        this.saveTuition(res)
      });
    },

    addTuition(){
      this.saveTuition([this.saveQuery])
    },

    saveTuition(params){
      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "저장 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          modalOptions = kuaaFnc.getSwalModaloptions();
          kuaaApi.sendServer(
            URL_CONST.SAVE_TUITION_LIST,
            params,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `저장 되었습니다.`;
                Swal.fire(modalOptions);
                this.resetView();
              } else {
                modalOptions.html = `저장 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );
        }
      });
    },

    updateTuition(){
      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "수정 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          modalOptions = kuaaFnc.getSwalModaloptions();
          kuaaApi.sendServer(
            URL_CONST.UPDATE_TUITION,
            this.saveQuery,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `수정 되었습니다.`;
                Swal.fire(modalOptions);
                this.resetView();
              } else {
                modalOptions.html = `수정 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );
        }
      });
    },

    deleteTuition(){
      let rows = this.$refs.TuitionList.invoke('getCheckedRows');

      if(!rows.length){
        Swal.fire(kuaaFnc.getSwalModaloptions({'html':'대상을 선택 해 주세요'}));
        return;
      }

      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "삭제 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          modalOptions = kuaaFnc.getSwalModaloptions();
          kuaaApi.sendServer(
            URL_CONST.DELETE_TUITION_LIST,
            rows,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `삭제 되었습니다.`;
                Swal.fire(modalOptions);
                this.resetView();
              } else {
                modalOptions.html = `삭제 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );
        }
      });
    }
  }
}
</script>

<style>

</style>